import canPlayOriginalVideo from '@anm/helpers/canPlayOriginalVideo';
import getUniqueSources from '@anm/helpers/getUniqueSources';
import isEqual from 'lodash/fp/isEqual';
import React, { memo, FC } from 'react';

import { MediaObject } from '../../../types';

type VideoSourcesProps = {
  sources: MediaObject[];
};

const VideoSources: FC<VideoSourcesProps> = ({ sources }) => {
  const getQuality = (height: number) => {
    switch (true) {
      case height < 360:
        return 240;
      case height < 480:
        return 360;
      case height < 720:
        return 480;
      case height < 1080:
        return 720;
      case height < 1440:
        return 1080;
      case height < 2160:
        return 1440;
      case height < 2880:
        return 2160;
      case height < 4320:
        return 2880;
      default:
        return 4320;
    }
  };

  const getSizeProps = (height: number) => ({ size: `${getQuality(height)}` });

  const firstSource = sources[0];
  const isOnlyOriginal = sources.length === 1 && !!firstSource.isOriginal;
  const canPlayOriginal = canPlayOriginalVideo(sources);

  if (isOnlyOriginal && !canPlayOriginal) return null;

  const filteredSources = !canPlayOriginal ? sources.filter(s => !s.isOriginal) : getUniqueSources(sources);

  return (
    <>
      {filteredSources.map(({ path, height }) => (
        <source src={path} key={path} {...getSizeProps(height)} />
      ))}
    </>
  );
};

const MemoizedVideoSources = memo(VideoSources, (prev: VideoSourcesProps, next: VideoSourcesProps) =>
  isEqual(prev, next)
);

export default MemoizedVideoSources;
